import { z } from "zod";
import {
  GENESYS_DEFAULT_REGION,
  IntegrationProvider,
  NICE_CXONE_DEFAULT_AREA,
  NICE_CXONE_DEFAULT_SEA_REGION
} from "../entities/integration.js";
function deserializeIntegrationSettingsDb(provider, settings) {
  const dbSettings = typeof settings === "object" ? settings : {};
  switch (provider) {
    case IntegrationProvider.SALESFORCE:
      return {
        ...defaultSalesforceIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.SLACK:
      return {
        ...defaultSlackIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.TEAMS:
      return {
        ...defaultTeamsIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.FOUNTAIN:
      return {
        ...defaultFountainIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.INTERNAL_TWILIO_SUB_ACCOUNT:
      return {
        ...dbSettings
      };
    case IntegrationProvider.EXTERNAL_TWILIO_SUB_ACCOUNT:
      return {
        ...dbSettings
      };
    case IntegrationProvider.GREENHOUSE:
      return {
        ...defaultGreenhouseIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.FIVE9_RECORDING_S3_INTAKE:
      return {
        ...defaultFive9RecordingS3IntakeIntegrationSettings,
        ...dbSettings,
        enabled: readRecordingS3IntakeEnabled(dbSettings)
      };
    case IntegrationProvider.RINGCENTRAL_RECORDING_S3_INTAKE:
      return {
        ...defaultRingCentralRecordingS3IntakeIntegrationSettings,
        ...dbSettings,
        enabled: readRecordingS3IntakeEnabled(dbSettings)
      };
    case IntegrationProvider.KUSTOMER:
      return {
        ...defaultKustomerIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.GURU:
      return {
        ...defaultGuruIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.GENESYS:
      return {
        ...defaultGenesysIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.ZOOM_CONTACT_CENTER:
      return {
        ...defaultZoomContactCenterIntegrationSettings,
        ...dbSettings
      };
    case IntegrationProvider.API_RECORDING_UPLOAD:
      return {};
    case IntegrationProvider.NICE_CXONE:
      return {
        ...defaultNiceCxoneIntegrationSettings,
        ...dbSettings
      };
  }
}
const defaultNiceCxoneIntegrationSettings = {
  area: NICE_CXONE_DEFAULT_AREA,
  access_key_id: "",
  enc_access_key_secret: "",
  sea_bucket: "",
  sea_prefix: "",
  sea_region: NICE_CXONE_DEFAULT_SEA_REGION,
  sea_aws_access_key_id: "",
  enc_sea_aws_secret_access_key: "",
  agent_roster: [],
  is_enabled: false
};
const defaultSalesforceIntegrationSettings = {
  instance_url: null,
  is_enabled: false
};
const defaultSlackIntegrationSettings = {
  channel_id: null
};
const defaultTeamsIntegrationSettings = {
  // Populated from the admin-consent redirect when the tenant connects
  tenant_id: null
};
const defaultFountainIntegrationSettings = {
  api_base_url: null
};
const defaultGreenhouseIntegrationSettings = {
  advancement_stage_name: null,
  integration_system_user_email: null
};
function readRecordingS3IntakeEnabled(dbSettings) {
  const enabled = dbSettings ? dbSettings.enabled : void 0;
  return enabled === void 0 || enabled === true;
}
const defaultFive9RecordingS3IntakeIntegrationSettings = {
  bucket: "",
  enabled: true,
  example_object_key: "",
  aws_access_key_id: "",
  enc_aws_secret_access_key: ""
};
const defaultRingCentralRecordingS3IntakeIntegrationSettings = {
  ...defaultFive9RecordingS3IntakeIntegrationSettings,
  client_id: "",
  enc_client_secret: "",
  enc_jwt: "",
  ringcx_sub_account_id: null
};
const defaultKustomerIntegrationSettings = {
  org_name: "",
  enc_api_key: "",
  knowledge_base_ids: []
};
const defaultGuruIntegrationSettings = {
  collections: []
};
const defaultGenesysIntegrationSettings = {
  client_id: "",
  enc_client_secret: "",
  region: GENESYS_DEFAULT_REGION,
  is_enabled: false,
  last_conversation_end_at: null,
  playbook_id: null
};
const defaultZoomContactCenterIntegrationSettings = {
  account_id: "",
  client_id: "",
  enc_client_secret: "",
  api_url: null,
  is_enabled: false,
  last_recording_end_at: null,
  playbook_id: null,
  rate_limits: null
};
const slackChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
  /**
   * Private channels are only ever listed when the bot is a member, so a
   * private channel that reaches a picker is one we can already post to.
   */
  is_private: z.boolean()
});
function parseSlackChannels(channels) {
  return z.array(slackChannelSchema).parse(channels);
}
export {
  defaultFive9RecordingS3IntakeIntegrationSettings,
  defaultFountainIntegrationSettings,
  defaultGenesysIntegrationSettings,
  defaultGreenhouseIntegrationSettings,
  defaultGuruIntegrationSettings,
  defaultKustomerIntegrationSettings,
  defaultRingCentralRecordingS3IntakeIntegrationSettings,
  defaultSlackIntegrationSettings,
  defaultTeamsIntegrationSettings,
  defaultZoomContactCenterIntegrationSettings,
  deserializeIntegrationSettingsDb,
  parseSlackChannels,
  slackChannelSchema
};
//# sourceMappingURL=integrations.js.map
